import React from "react";
import { useTranslation } from "react-i18next";
import { calculateProjectRatio } from "../../domain/services/portfolioMetricsService";

export default function ComparativeWindowContent({ summary, projects }) {
  const { t } = useTranslation("aiPortfolio");

  return (
    <>
      <div className="quickMetrics">
        <p>
          {t("comparative.withoutAi")}: {summary.withoutAi}h
        </p>
        <p>
          {t("comparative.withAi")}: {summary.withAi}h
        </p>
        <p>
          {t("comparative.avgGain")}: -{summary.gain}%
        </p>
      </div>

      {projects.map((project) => {
        const ratio = calculateProjectRatio(project);
        return (
          <div key={project.id} className="compareRow">
            <strong>{project.name}</strong>
            <span>
              {project.withoutAiLabel} -> {project.withAiLabel}
            </span>
            <div className="compareBar">
              <div className="without" />
              <div className="with" style={{ width: `${ratio}%` }} />
            </div>
          </div>
        );
      })}
    </>
  );
}
